import { render } from "./FooterSmall.vue?vue&type=template&id=8da9ec2a"
import script from "./FooterSmall.vue?vue&type=script&lang=js"
export * from "./FooterSmall.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Desktop\\项目\\褐飞虱\\vue-notus-main\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__